/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import cx from 'clsx';
import uniqBy from 'lodash/uniqBy';
import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';
import useTranslation from 'next-translate/useTranslation';
import sidekick from '@last-rev/contentful-sidekick-util';
import ModuleHero, { ModuleHeroPropTypes } from '../ModuleHero';
import VideoCard, { VideoCardPropTypes } from '../ModuleCard/VideoCard';
import ContentModule from '../ContentModule';
import ModulePagination from '../ModulePagination';
import styles from './PageVideoLanding.module.scss';
import Breadcrumb from '../Breadcrumb';
import Asset from '../Asset';
import Link from 'next/link';
export const FilterSelectPropTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string)
};

export const PageVideoLandingPropTypes = {
  _id: PropTypes.string.isRequired,
  _contentTypeId: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  videosPerPage: PropTypes.number,
  introHero: PropTypes.shape(ModuleHeroPropTypes),
  videos: PropTypes.arrayOf(PropTypes.shape(VideoCardPropTypes)),
  contentSections: PropTypes.array,
  wistiaVideos: PropTypes.shape({ videos: PropTypes.array }),
  page: PropTypes.number,
  currentVideos: PropTypes.arrayOf(PropTypes.shape(VideoCardPropTypes))
};

export const FilterHeadingPropTypes = {
  option: PropTypes.string.isRequired,
  handleFilterHeadingClick: PropTypes.func.isRequired
};

const FilterHeading = ({ option, handleFilterHeadingClick }) => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const mobileCheck = document.querySelector('.mobile-check');
    setIsMobile(mobileCheck.getClientRects().length !== 0);
  }, []);

  return (
    <a
      data-testid={`PageVideoLanding-filterHeading-${option}`}
      className={cx(styles.filterHeading, 'filterHeading')}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        handleFilterHeadingClick(option, e);
      }}
      data-uxa-log={`video_filter_heading_${option.toLowerCase().replace(/\s+/g, '_')}`}
      data-uxa-interactions="click shown"
      href="#">
      {option}
    </a>
  );
};

const PageVideoLanding = ({
  _id,
  _contentTypeId,
  slug,
  introHero = null,
  videos = null,
  videosPerPage = 12,
  contentSections = [],
  wistiaVideos = { videos: [] },
  page = 1,
  currentVideos,
  breadcrumbs
}) => {
  const IndexedVideosOnly = videos?.filter((vid) => {
    const robots = vid?.seo?.robots?.value?.toLowerCase() || "";
    return robots.split(",").map((s) => s.trim()).includes("index");
  });
  const dedupedVideos = uniqBy(IndexedVideosOnly, (video) => video._id).sort(
    (a, b) => new Date(b._createdDate) - new Date(a._createdDate)
  );
  // Force 10 cards for widths <= 768px, 12 cards for widths > 768px
  const getInitialPerPage = () => {
    if (typeof window === 'undefined') return 12;
    const width = window.innerWidth;
    return width <= 768 ? 10 : 12;
  };

  const [videosPerPageState, setVideosPerPageState] = useState(getInitialPerPage);
  const [shownoresultsPage, setShowResultsPage] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const perPage = width <= 768 ? 10 : 12;
      setVideosPerPageState(perPage);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Debug: log actual width and per-page value


  const [currentPage, setCurrentPage] = useState(page);
  const [videoPages, setVideoPages] = useState(dedupedVideos?.slice(0, videosPerPageState));
  const [filteredVideos, setFilteredVideos] = useState(
    dedupedVideos.slice(0, videosPerPageState)
  );
  const [shownVideos, setShownVideos] = useState(dedupedVideos);
  const [activeCategory, setActiveCategory] = useState([]);
  const [isMobile, setIsMobile] = React.useState(false);
  const { t } = useTranslation();
  const router = useRouter();
  const [searchquery, setSearchquery] = useState('');
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [totalFiltersCount, setTotalFiltersCount] = useState(0)
  const [showclearButton, setshowClearButton] = useState([])
  // Helper: determine if any filter or search is active
  const hasActiveFilters = Boolean(
    searchquery ||
    router.query?.k ||
    router.query?.categories ||
    router.query?.subcategories
  );
  useEffect(() => {
    const mobileCheck = document.querySelector('.mobile-check');
    setIsMobile(mobileCheck.getClientRects().length !== 0);
  }, []);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const subtag = urlParams.get('subcategories')?.replace(/[\[\]]/g, '').trim();
    const cattag = urlParams.get('categories')?.replace(/[\[\]]/g, '').trim();

    const ktag = urlParams.get('k')
    const arraygCatTagItems = cattag && cattag.split(',')
    const arraySubTagItems = subtag && subtag.split(",")
    setTotalFiltersCount(
      (arraygCatTagItems?.length || 0) + (arraySubTagItems?.length || 0)
    ); if (subtag && cattag) {

      const filtercategory = dedupedVideos.filter((video, index) => {
        return video?.subjects && arraygCatTagItems.includes(video?.subjects)
      })
      const filtersubcategory = dedupedVideos.filter((video, index) => {
        return video?.tags && video?.tags.some(tag => arraySubTagItems.includes(tag))
      })
      const combined = [...filtercategory, ...filtersubcategory]
      const uniqueResult = Array.from(
        new Map(combined.map(item => [item._id, item])).values())
      const filteredcatData = uniqueResult.slice((currentPage - 1) * videosPerPageState, currentPage * videosPerPageState);
      setFilteredVideos(filteredcatData)
      setShownVideos(uniqueResult)
      highlightFilterOnload()
    }
    else if (cattag) {
      const filtercategory = dedupedVideos.filter((video, index) => {
        return video?.subjects && arraygCatTagItems.includes(video?.subjects)
      })
      const filteredcatData = filtercategory.slice((currentPage - 1) * videosPerPageState, currentPage * videosPerPageState);
      setFilteredVideos(filteredcatData)
      setShownVideos(filtercategory)
      highlightFilterOnload()

    }
    else if (subtag) {
      const filtersubcategory = dedupedVideos.filter((video, index) => {
        return video?.tags && video?.tags.some(tag => arraySubTagItems.includes(tag))
      })
      const filteredsubData = filtersubcategory.slice((currentPage - 1) * videosPerPageState, currentPage * videosPerPageState);
      setFilteredVideos(filteredsubData)
      setShownVideos(filtersubcategory)
      highlightFilterOnload()

    }
    else if (ktag) {
      if (router.isReady) {
        const searchValue = router?.query?.k
        const trimSpaces = searchValue.toLowerCase().trim()
        const limitAndSet = (list) => {
          setFilteredVideos(list.length > videosPerPageState ? list.slice((currentPage - 1) * videosPerPageState, currentPage * videosPerPageState) : list)
          setShownVideos(list)

        }
        const filters = [
          dedupedVideos.filter(item =>
            (item?.tags || []).some(tag => tag?.toLowerCase().trim().includes(trimSpaces))
          ),
          dedupedVideos.filter(item => item?.subjects && item?.subjects.toLowerCase().trim().includes(trimSpaces)),
          dedupedVideos.filter(item => item?.pageTitle && item?.pageTitle.toLowerCase().trim().includes(trimSpaces)),
          dedupedVideos.filter(item => item?.videoTitle && item?.videoTitle.toLowerCase().trim().includes(trimSpaces)),
          dedupedVideos.filter(item => item?.videoSummary && item?.videoSummary.toLowerCase().trim().includes(trimSpaces)),
          dedupedVideos.filter(item =>
            item?.transcript?.content?.some(c => c?.content?.[0]?.value && c?.content?.[0]?.value.toLowerCase().trim().includes(trimSpaces))
          )
        ]
        const result = filters.filter(list => list.length > 0).flat();
        const uniqueResult = Array.from(
          new Map(result.map(item => [item._id, item])).values())
        if (uniqueResult && uniqueResult.length > 0) {
          limitAndSet(uniqueResult)
          setShowResultsPage(false)
        }
        else {
          setFilteredVideos([]);
          setShownVideos([])
          setShowResultsPage(true)
        }
        setSearchquery(router?.query?.k)

      }
      highlightFilterOnload()
    }
    else {
      setFilteredVideos(dedupedVideos.slice((currentPage - 1) * videosPerPageState, currentPage * videosPerPageState));
      setShownVideos(dedupedVideos)
      highlightFilterOnload()

    }

  }, [router?.asPath, router.isReady, videosPerPageState])
 
  const highlightFilterOnload = (() => {

    const filtersContainer = document.querySelector('[data-testid="PageVideoLanding-filters"]');
    if (filtersContainer) {
      const anchorTags = filtersContainer.querySelectorAll(".filterHeading");
      const categoryValue = router.query?.categories;
      const subcategoryValue = router.query?.subcategories;

      const categoryArray = categoryValue
        ? categoryValue.replace(/^\[|\]$/g, '').split(',').map(v => v.trim())
        : [];

      const subcategoryArray = subcategoryValue
        ? subcategoryValue.replace(/^\[|\]$/g, '').split(',').map(v => v.trim())
        : [];

      let activeArray = [];
      let activeAnchorText = null;

      if (categoryArray.length && subcategoryArray.length) {
        activeArray = [...categoryArray, ...subcategoryArray];
        activeAnchorText = null;
      } else if (categoryArray.length) {
        activeArray = categoryArray;
        activeAnchorText = anchorTags[0]?.innerText.toLowerCase();
      } else if (subcategoryArray.length) {
        activeArray = subcategoryArray;
        activeAnchorText = anchorTags[1]?.innerText.toLowerCase();
      } else {
        // no filters selected: open ALL headings on desktop
        activeAnchorText = "showALLList";
      }

      anchorTags.forEach((ele) => {
        const anchorText = ele.textContent.toLowerCase();

        if (window.innerWidth > 1024) {
          if (!activeAnchorText || activeAnchorText === "showALLList" || anchorText === activeAnchorText) {
            ele.classList.add(styles.open);
          } else {
            ele.classList.remove(styles.open);
          }
        } else {
          ele.classList.remove(styles.open);
        }

        const subLinks = ele.nextElementSibling;
        if (!subLinks) return;

        subLinks.querySelectorAll('a').forEach((a) => {
          window.innerWidth > 1024 ? a.style.textDecoration = 'none' : a.classList.remove(styles.active);
          if (activeArray.includes(a.textContent) || activeArray.includes(a.dataset.slug)) {
            window.innerWidth > 1024 ? a.style.textDecoration = 'underline' : a.style.textDecoration = 'none';
            a.classList.add(styles.active);
          }
        });
      });
    }
  });
  const pageCount = Math.ceil(dedupedVideos?.length / videosPerPageState);

  const removeClass = (elementClass) => {
    const classNames = {
      checkbox: styles.active,
      filterHeading: styles.open
    };
    Array.from(document.querySelectorAll(`.${elementClass}`)).forEach((elem) => {
      elem?.classList?.remove(classNames[elementClass] || '');
    });
  };

  const sortByValue = (a, b) => {
    return a.value.localeCompare(b.value);
  }

  // NOTE: Categories and Subcategories are labels only, not prop names, which are subjects and tags respectively
  // ie. In Contentful, Tags were changed to Subcategories and Subjects changed to Categories
  const getFilters = () => {
    const categories = [];
    const subcategories = [];
    if (videos && videos.length > 0) {
      videos.forEach((video) => {
        video?.tags?.forEach((category) => {
          if (category) {
            const subcategoryLabel = upperFirst(camelCase(category));
            const key = `common:pageVideoSubcategories${subcategoryLabel}`;
            if (!subcategories.some((c) => c.value === category)) {
              subcategories.push({
                value: category,
                label: subcategoryLabel ? t(key) !== key ? t(key) : category : category
              });
            }
          }
        });

        const categoryValue = video.subjects;
        if (categoryValue) {
          const categoryLabel = upperFirst(camelCase(categoryValue));
          if (!categories.some((c) => c.value === categoryValue) && categoryValue!=="Organizar") {
            categories.push({
              value: categoryValue,
              label: categoryLabel ? t(`common:pageVideoCategories${categoryLabel}`) : categoryValue
            });
          }
        }
      });
    }

    return [
      {
        category: 'categories',
        label: t('common:labelCategories'),
        options: categories.sort(sortByValue)
      },
      {
        category: 'subcategories',
        label: t('common:labelSubcategories'),
        options: subcategories.sort(sortByValue)
      }
    ];
  };
  const filters = getFilters();
  const selectedCategories = React.useMemo(() => {
    const raw = router.query?.categories;
    if (!raw) return [];
    return raw
      .replace(/^\[|\]$/g, '')
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean);
  }, [router.query?.categories]);

  const selectedSubcategories = React.useMemo(() => {
    const raw = router.query?.subcategories;
    if (!raw) return [];
    return raw
      .replace(/^\[|\]$/g, '')
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean);
  }, [router.query?.subcategories]);

  const handleFilterHeadingClick = (option, e) => {
    // On desktop, keep headings always open via highlightFilterOnload; don't toggle here
    if (typeof window !== 'undefined' && window.innerWidth > 1024) return;

    const headingEl = e.currentTarget;
    const isOpen = headingEl.classList.contains(styles.open);

    if (isMobile) removeClass('filterHeading');

    if (isOpen) {
      headingEl.classList.remove(styles.open);
    } else {
      headingEl.classList.add(styles.open);
    }
  };

  const showSelectedCards = (option, category) => {
    const selectedOption = camelCase(option);
    const selectedFilter = category === 'categories' ? `category-${selectedOption}` : `subcategory-${selectedOption}`;
    const videoCards = document.querySelectorAll('.videoCard');
    const visibleCards = [];
    Array.from(videoCards).forEach((card) => {
      const videoCard = card;
      videoCard.style.display = 'block';
      if (!card.classList.contains(selectedFilter)) {
        videoCard.style.display = 'none';
      } else {
        visibleCards.push(card);
      }
    });
    setShownVideos(visibleCards);
  };


  const handleCardSubCategoryFilter = (category, e) => {
    e.preventDefault();
    e.stopPropagation();
    showSelectedCards(category, 'subcategories');

    const url = new URL(window.location.href);
    url.searchParams.set('subcategory', camelCase(category));
    window.history.pushState({}, '', url.toString());
  };

  const handleListFilter = (option, category, e) => {
    if (e) {
      e.preventDefault?.();
      e.stopPropagation?.();
    }
    setCurrentPage(1);
    setSearchquery("");
    setShowResultsPage(false)
    setshowClearButton(prev=>{
      if(prev.includes(option)){
        return prev.filter(item=>item !==option)
      }
      return [...prev, option]
    })
    const existingQuery = { ...router.query };
    let currentValues = existingQuery[category]
      ? existingQuery[category]
        .replace(/^\[|\]$/g, '')
        .split(',')
        .map((v) => v.trim())
        .filter(Boolean)
      : [];

    if (currentValues.includes(option)) {
      currentValues = currentValues.filter((v) => v !== option);
    } else {
      currentValues.push(option);
    }
    const newQuery = { ...existingQuery, [category]: `[${currentValues.join(',')}]` };

    if (currentValues.length === 0) delete newQuery[category];

    delete newQuery.slug;

    const queryString = [
      newQuery.categories ? `categories=[${newQuery.categories.replace(/^\[|\]$/g, '')}]` : null,
      newQuery.subcategories ? `subcategories=[${newQuery.subcategories.replace(/^\[|\]$/g, '')}]` : null
    ]
      .filter(Boolean)
      .join('&');

    router.push(
      `/video-library/page/1${queryString ? `?${queryString}` : ''}`,
      undefined,
      { shallow: true }
    );
  };


  const handleClearFilter = (e) => {
    e.preventDefault();
    removeClass('checkbox');
    removeClass('filterHeading');
    setFilteredVideos(dedupedVideos.slice(0, videosPerPageState));
    setShownVideos(dedupedVideos);
    setCurrentPage(1);
    setSearchquery("");
    router.push(`/video-library/page/1`, undefined, { shallow: true });
    setShowMobileFilters(false);
    setShowResultsPage(false)
    setshowClearButton([])
  };

  const handleApplyMobileFilters = () => {
    // Just close overlay; filters already applied via checkboxes/router
    setShowMobileFilters(false);
  };
  const handlePageChange = (pageNumber) => {
    const pageIndex = pageNumber - 1;
    const firstIndex = pageIndex * videosPerPageState;
    const lastIndex = firstIndex + videosPerPageState;

    const paginatedVideos = [];
    for (let i = 0; i < shownVideos.length; i += videosPerPageState) {
      paginatedVideos.push(shownVideos.slice(i, i + videosPerPageState));
    }

    if (activeCategory && shownVideos.length > videosPerPageState) {
      setVideoPages(paginatedVideos[pageIndex]);
    } else {
      setVideoPages(dedupedVideos.slice(firstIndex, lastIndex));
    }
    setCurrentPage(pageNumber);
  };


  React.useEffect(() => {
    const { page: newPage } = router.query;
    if (newPage) {
      const pageNumber = Number(newPage);
      if (!Number.isNaN(pageNumber)) {
        handlePageChange(pageNumber);
      }
    }
  }, [router.query]);


  const getWistiaData = (id) => {
    if (!wistiaVideos?.videos?.length) {
      return null;
    }

    const wistiaData = wistiaVideos.videos.find((video) => video.hashed_id === id);
    if (wistiaData) {
      return {
        name: wistiaData.name,
        description: wistiaData.description,
        thumbnail: wistiaData.thumbnail
      };
    }
    return null;
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    router.push(`/video-library/page/1?k=${value}`, undefined, { shallow: true });
    if (value == "") {
      handleClearFilter(event);
    }
    setSearchquery(value);
    setshowClearButton(["search"])
  };

  const handleSearchClear = (event) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    setSearchquery("");
    router.push(`/video-library/page/1`, undefined, { shallow: true });
    setFilteredVideos(dedupedVideos.slice(0, videosPerPageState));
    setShownVideos(dedupedVideos);
    setCurrentPage(1);
    setShowResultsPage(false)
  };

  const openMobileFilters = () => setShowMobileFilters(true);
  const closeMobileFilters = () => setShowMobileFilters(false);


  return (
    <div
      key="PageVideoLanding"
      data-testid="PageVideoLanding"
      className={styles.page}
      {...sidekick(_id, null, _contentTypeId, 'Page Video Landing')}>
      <Breadcrumb breadcrumbs={breadcrumbs}></Breadcrumb>

      {introHero
        ? (() => (
          <ModuleHero
            _id={introHero._id}
            _contentTypeId={introHero._contentTypeId}
            headerText={introHero.headerText}
            summaryText={introHero.summaryText}
            image={introHero.image}
            className={`theme-${slug}`}
          />
        ))()
        : null}

      <div className={`container py-4 mt-2 ${styles.container}`}>
        <div className={`row g-0 ${styles.row}`}>
          <div className={`col-24 col-md-5 mb-4 p-0 ${styles.filterColumn}`}>
            <div className={styles.filtersContainer}>
              {/* Search Box with Icon */}
              <div className={cx(styles.searchContainer)}>
                <Asset url="/images/assets/SearchIcon.svg"></Asset>
                <input
                  type="text"
                  value={searchquery}
                  onChange={handleSearchChange}
                  placeholder="Search..."
                  className={cx(styles.searchBox, 'form-control')}
                />
                {searchquery && (
                  <button
                    type="button"
                    className={styles.searchClear}
                    onClick={handleSearchClear}
                    aria-label="Clear search"
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 6.5L6.5 17.5M17.5 17.5L6.5 6.5" stroke="#1A1918" strokeWidth="1.5" strokeMiterlimit="10"></path></svg>
                  </button>
                )}
              </div>
              {/* Filter button (acts as trigger on mobile) */}
              <button
                type="button"
                className={cx(styles.filterLabelButton, 'mb-3')}
                onClick={openMobileFilters}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M11.893 6.00001C11.7664 5.53952 11.4831 5.13765 11.0918 4.8638C10.7006 4.58994 10.226 4.46127 9.75 4.50001C9.274 4.46127 8.79942 4.58994 8.40817 4.8638C8.01692 5.13765 7.73356 5.53952 7.607 6.00001H5V7.50001H7.607C7.73356 7.96051 8.01692 8.36238 8.40817 8.63623C8.79942 8.91009 9.274 9.03875 9.75 9.00001C10.226 9.03875 10.7006 8.91009 11.0918 8.63623C11.4831 8.36238 11.7664 7.96051 11.893 7.50001H19V6.00001H11.893ZM9.75 7.50001C9.1895 7.50001 9 7.31101 9 6.75001C9 6.18901 9.1895 6.00001 9.75 6.00001C10.3105 6.00001 10.5 6.18901 10.5 6.75001C10.5 7.31101 10.3105 7.50001 9.75 7.50001Z" fill="#1A1918" />
                  <path d="M14.25 9.50001C13.774 9.46127 13.2994 9.58994 12.9082 9.86379C12.5169 10.1377 12.2336 10.5395 12.107 11H5V12.5H12.107C12.2336 12.9605 12.5169 13.3624 12.9082 13.6362C13.2994 13.9101 13.774 14.0388 14.25 14C14.726 14.0388 15.2006 13.9101 15.5918 13.6362C15.9831 13.3624 16.2664 12.9605 16.393 12.5H19V11H16.393C16.2664 10.5395 15.9831 10.1377 15.5918 9.86379C15.2006 9.58994 14.726 9.46127 14.25 9.50001ZM14.25 12.5C13.6895 12.5 13.5 12.311 13.5 11.75C13.5 11.189 13.6895 11 14.25 11C14.8105 11 15 11.189 15 11.75C15 12.311 14.8105 12.5 14.25 12.5Z" fill="#1A1918" />
                  <path d="M9.75 14.5C9.274 14.4613 8.79942 14.5899 8.40817 14.8638C8.01692 15.1377 7.73356 15.5395 7.607 16H5V17.5H7.607C7.73356 17.9605 8.01692 18.3624 8.40817 18.6362C8.79942 18.9101 9.274 19.0388 9.75 19C10.226 19.0388 10.7006 18.9101 11.0918 18.6362C11.4831 18.3624 11.7664 17.9605 11.893 17.5H19V16H11.893C11.7664 15.5395 11.4831 15.1377 11.0918 14.8638C10.7006 14.5899 10.226 14.4613 9.75 14.5ZM9.75 17.5C9.1895 17.5 9 17.311 9 16.75C9 16.189 9.1895 16 9.75 16C10.3105 16 10.5 16.189 10.5 16.75C10.5 17.311 10.3105 17.5 9.75 17.5Z" fill="#1A1918" />
                </svg>
                <span>{t('common:textFilterBy')} {totalFiltersCount > 0 && ` (${totalFiltersCount})`}</span>
              </button>
              <div className={cx(styles.filtersWrap, 'filtersWrap')} data-testid="PageVideoLanding-filters">
                {filters.map((filter) => (
                  <div className={styles.filterWrap} key={filter.category}>
                    <div className={styles.filterHead}>
                      <FilterHeading option={filter.label} handleFilterHeadingClick={handleFilterHeadingClick} />
                      {filter.category === 'categories' && showclearButton.length>0 && (
                        <p className={cx(styles.filterLabeldesk)}>
                          <a
                            href="#"
                            className={styles.clear}
                            onClick={(e) => handleClearFilter(e)}
                            data-uxa-log="video_clear_filter"
                            data-uxa-interactions="click shown"
                          >
                            {t('common:textClear')}
                          </a>
                        </p>
                      )}
                    </div>
                    <ul className={styles.filterList}>
                      {filter.options.map((option) => {
                        const isChecked =
                          filter.category === 'categories'
                            ? selectedCategories.includes(option.value)
                            : selectedSubcategories.includes(option.value);

                        return (
                          <li key={camelCase(option.value)}>
                            <div className={styles.filterOptionRow}>
                              <input
                                type="checkbox"
                                className={styles.filterCheckbox}
                                checked={isChecked}
                                onChange={(e) => handleListFilter(option.value, filter.category, e)}
                              />
                              <span className={styles.filterLabelText}>{option.label}</span>

                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ))}
              </div>
              <p className={cx(styles.filterLabel, 'mt-3')}>
                <a href="#" className={styles.clear} onClick={(e) => handleClearFilter(e)} data-uxa-log="video_clear_filter" data-uxa-interactions="click shown">
                  {t('common:textClear')}
                </a>
              </p>

              {/* Mobile full-screen filters overlay */}
              {showMobileFilters && (
                <div className={styles.mobileFiltersOverlay}>
                  <div className={styles.mobileFiltersHeader}>
                    <span>Filter</span>
                    <button type="button" className={styles.mobileFiltersClose} onClick={closeMobileFilters}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.5 6.5L6.5 17.5M17.5 17.5L6.5 6.5" stroke="#1A1918" strokeWidth="1.5" strokeMiterlimit="10" />
                      </svg>
                    </button>
                  </div>
                  <div className={styles.mobileFiltersBody}>
                    {filters.map((filter) => (
                      <div className={styles.filterWrap} key={filter.category}>
                        <div className={styles.filterHead}>
                          <FilterHeading option={filter.label} handleFilterHeadingClick={handleFilterHeadingClick} />
                        </div>
                        <ul className={styles.filterList}>
                          {filter.options.map((option) => {
                            const isChecked =
                              filter.category === 'categories'
                                ? selectedCategories.includes(option.value)
                                : selectedSubcategories.includes(option.value);

                            return (
                              <li key={camelCase(option.value)}>
                                <div className={styles.filterOptionRow}>
                                  <input
                                    type="checkbox"
                                    className={styles.filterCheckbox}
                                    checked={isChecked}
                                    onChange={(e) => handleListFilter(option.value, filter.category, e)}
                                  />
                                  <span className={styles.filterLabelText}>{option.label}</span>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    ))}
                    <div className={styles.mobileFiltersFooter}>
                      <button
                        type="button"
                        className={styles.mobileFiltersClear}
                        onClick={handleClearFilter}
                      >
                        {t('common:clearall')}
                      </button>
                      <button
                        type="button"
                        className={styles.mobileFiltersApply}
                        onClick={handleApplyMobileFilters}
                      >
                        {`${t('common:see')} ${shownVideos?.length || 0} ${t('common:results')}`}
                      </button>
                    </div>
                  </div>
              
                </div>
              )}
            </div>
          </div>
          <div className={`col-24 col-md-19 p-0 ${styles.videoColumn}`}>
            {hasActiveFilters ? (
              <p className={styles.resultsCount}>
                {`${shownVideos?.length || 0} ${t('common:searchResultStatus')}`}
              </p>
            ) : ""}
            {
              shownoresultsPage && (
                <div className={styles.nodataFoundWrapper}>
                  <span className={styles.dogIcon}></span>
                  <div className={styles.bodyText}>
                    <span className={styles.noData}>{t('common:noData')}</span>
                    <span className={styles.noresultText}><span>{t('common:noresultText')} </span>
                      <Link href="/video-library">
                        <a onClick={() => {
                          setShowResultsPage(false)
                          setSearchquery("")
                        }}>
                          {t('common:alltutorials')}
                        </a>
                      </Link></span>
                  </div>
                </div>
              )
            }
            <div className={cx(styles.cardWrap, 'cardWrapper')} data-testid="PageVideoLanding-videos">

              {videos && videos.length > 0
                ? filteredVideos.map((video) => (
                  <VideoCard
                    key={video?._id}
                    _id={video?._id}
                    headerText={video?.videoTitle}
                    summaryText={video?.videoSummary}
                    image={video?.videoCardImage}
                    tags={video?.tags}
                    subjects={video?.subjects}
                    slug={`/${slug}/${video?.slug}`}
                    tagFilter={handleCardSubCategoryFilter}
                    className={styles.videoCard}
                    router={router}
                    wistiaData={getWistiaData(video?.video?.videoId)}
                  />
                ))
                : null}
            </div>

            {pageCount > 1 && shownVideos?.length > videosPerPageState && (
              <div className={`${styles.head} my-5 d-flex justify-content-center`}>
                <ModulePagination
                  totalPages={
                    shownVideos.length === videos.length ? pageCount : Math.ceil(shownVideos.length / videosPerPageState)
                  }
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={cx(styles.mobile, 'mobile-check')} />
    </div>
  );
};

FilterHeading.propTypes = FilterHeadingPropTypes;

PageVideoLanding.propTypes = PageVideoLandingPropTypes;

export default PageVideoLanding;